import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    Modal,
    Select,
    Tabs
} from 'antd';

// Components
import PageHeader from "../../Reusable/PageHeader";
import ReportTable from './ReportTable';
import { Flex, FlexColumn } from '../../Reusable/Container';
import { ErrorAlert } from '../../Reusable/Alert';
import { Text } from '../../Reusable/Text'
import AccountStatement from '../AccountStatement/Index'

// Util
import { apiPOSTReq } from '../../../Utils/api';
import environment from '../../../environment';

// Actions
import { withTheme } from 'styled-components';

import ModalClose from '../../../Images/modal-close.png';
import { getDate } from '../../../Utils/util';
import TableView from '../../Reusable/TableView';
import SearchAndFilter from '../SearchAndFilter'


const { Option } = Select;
const pageSize = 50;

const dFormat = "YYYY-MM-DD";
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const { TabPane } = Tabs

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customize: true,
            loadingPassThrough: true,
            loadingTransactions: true,
            loadingReport: true,
            pagination: {
                current: 1,
                pageSize: pageSize,
            },
            modalWidth: 900,
            dateType: "Year to Date",
            dailyReportItemList: [],
            collateralItemList: [],
            fromDate: null, toDate: null,
            tab: "LineHistory",
        };

        this.fetchData = this.fetchData.bind(this)
    }

    componentDidMount() {
        this.fetchData({ fromDate: null, toDate: null })
    }

    componentDidUpdate(prevProps) {
        let { location } = this.props
        var state = location.state ? location.state : {}
        if (state.reloadData) {
            this.props.location.state = {}
            this.fetchData({ fromDate: null, toDate: null })
        }
    }

    fetchData(options) {
        let { fromDate, toDate, pagination, fromApply, tab } = options;
        let fetchOptions = {
            sortFieldDirection: 'DESC',
            fromDate: fromDate,
            toDate: toDate,
            size: this.state.pagination.pageSize,
            page: this.state.pagination.current - 1,
            download: false,
        }
        if (pagination) {
            fetchOptions.size = pagination.pageSize;
            fetchOptions.page = pagination.current - 1;
        }

        if (fromDate) {
            fetchOptions.fromDate = fromDate;
            fetchOptions.toDate = toDate;
        }
        this.setState({ loading: true })

        if (!pagination) {
            pagination = this.state.pagination;
        }

        let url = `${environment.lsmBaseUrl}/lsm/getDailyReport`;
        if (tab == 'CollateralHistory') {
            url = `${environment.lsmBaseUrl}/lsm/getCollateralHistory`;
        }

        apiPOSTReq(url, {}, fetchOptions, (err, resp) => {
            try {
                const data = resp || {};
                if (data) {
                    var dailyReportItemList = fromApply ? data.dailyReportItemList : this.state.dailyReportItemList.concat(data.dailyReportItemList);
                    var collateralItemList = fromApply ? data.collateral : this.state.collateralItemList.concat(data.collateral);
                    var moreItem = tab != "CollateralHistory" ? (dailyReportItemList.length == data.count ? false : true) : (collateralItemList.length == data.count ? false : true);
                    this.setState({
                        ...options,
                        loading: false,
                        dailyReportItemList: dailyReportItemList || [],
                        collateralItemList: collateralItemList || [],
                        moreToLoad: moreItem,
                        pagination: {
                            ...pagination,
                            total: data.count,
                        },
                        availableStatements: data.availableStatements
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/counterparty err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    loadMoreData = () => {
        var updatedState = {
            dateType: "Custom",
            loading: true,
            pagination: {
                current: this.state.pagination.current + 1,
                pageSize: pageSize,
            },
            fromApply: false
        }
        this.fetchData({ ...this.state, ...updatedState })
    }

    onTabChange = tab => {
        this.setState({ tab: tab, dailyReportItemList: [], collateralItemList: [] });
        this.fetchData({
            pagination: {
                current: 1,
                pageSize: 50
            }, tab: tab
        });
    };

    render() {
        const { loading, transactions, passThrough, tab,
            loadingTransactions, loadingPassThrough, moreToLoad } = this.state;
        const { theme } = this.props;

        const columns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
                render: date => (moment(date).format('MMM Do, YYYY')),
                width: '100pt'
            },
            {
                title: 'Customer',
                dataIndex: 'CustomerName',
                key: 'CustomerName',
                width: '120pt'
            },
            {
                title: 'Description',
                dataIndex: 'DisplayDescription',
                key: 'Description',
            },
            {
                title: 'Type',
                dataIndex: 'DisplayType',
                key: 'Type',
            },
            {
                title: 'Credit/Debit',
                dataIndex: 'Amount',
                key: 'Amount',
                render: amount => (<b>{formatter.format(amount)}</b>),
                width: '100pt'
            },
            {
                title: 'Running Balance',
                dataIndex: 'BalanceEnd',
                key: 'BalanceEnd',
                render: balanceEnd => (formatter.format(balanceEnd)),
                width: '100pt'
            },
        ];

        const passThroughColumns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
                render: date => (moment(date).format('MMM Do, YYYY')),
                width: '100pt'
            },
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                key: 'CustomerName',
            },
            {
                title: 'Type',
                dataIndex: 'DisplayType',
                key: 'Type',
            },
            {
                title: 'Description',
                dataIndex: 'Description',
                key: 'Description',
            },
            {
                title: 'Amount',
                dataIndex: 'AmountStr',
                key: 'AmountStr',
                render: amount => (`$${amount}`),
                width: '100pt'
            },
        ];

        return (
            <FlexColumn className='main-padding'>
                <PageHeader
                    titleText="Credit"
                    subtitle="Revolving Line of Credit"
                />

                <Tabs size="large" style={{ width: '100%' }} activeKey={tab} onChange={this.onTabChange} >
                    <TabPane tab="Line History" key="LineHistory" />
                    <TabPane tab="Collateral History" key="CollateralHistory" />
                </Tabs>
                {
                    (tab == "LineHistory") &&
                    <ReportTable
                        titleText={
                            <div>
                                <Flex start fullWidth gap='24px' style={{ marginBottom: 12 }}>
                                    <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>
                                        {"Daily Credit Transactions"}
                                    </Text>
                                </Flex>
                                <Flex start fullWidth gap='24px'>
                                    <Text color={theme.colors.defaultLightText}>
                                        {"As of 9PM ET, " + ((this.state.dailyReportItemList || []).length > 0 ?
                                            moment(this.state.dailyReportItemList[0].reconciliationDate).format("MMM DD, yyyy")
                                            :
                                            moment().add(-1, 'day').format("MMM DD, yyyy"))}
                                    </Text>
                                </Flex>
                            </div>
                        }
                        pagination={false}
                        moreToLoad={moreToLoad}
                        onLoadMore={() => this.loadMoreData()}
                        loading={loading}
                        pageSize={pageSize}
                        componentType="Reports"
                        reports={this.state.dailyReportItemList || []}
                        fetchReport={this.fetchData}
                        ctaContent={
                            <Flex start fullWidth gap='24px'>
                                <SearchAndFilter
                                    clearAll={() => {
                                        this.setState({
                                            dailyReportItemList: [],
                                            fromDate: null, toDate: null,
                                            pagination: {
                                                current: 1,
                                                pageSize: pageSize,
                                            },
                                        })
                                        this.fetchData({
                                            fromDate: null, toDate: null, fromApply: false, pagination: {
                                                current: 1,
                                                pageSize: pageSize,
                                            },
                                        })
                                    }}
                                    fetchData={this.fetchData}
                                    pageSize={pageSize}
                                    tab={tab}
                                />
                            </Flex>
                        }
                    />
                }
                {
                    (tab == "CollateralHistory") &&
                    <ReportTable
                        titleText={
                            <div>
                                <Flex start fullWidth gap='24px' style={{ marginBottom: 12 }}>
                                    <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>
                                        {"Daily Collateral History"}
                                    </Text>
                                </Flex>
                                <Flex start fullWidth gap='24px'>
                                    <Text color={theme.colors.defaultLightText}>
                                        {"As of 9PM ET, " + ((this.state.collateralItemList || []).length > 0 ?
                                            moment(this.state.collateralItemList[0]?.reconciliationDate).format("MMM DD, yyyy")
                                            :
                                            moment().add(-1).format("MMM DD, yyyy"))}
                                    </Text>
                                </Flex>
                            </div>
                        }
                        pagination={false}
                        moreToLoad={moreToLoad}
                        onLoadMore={() => this.loadMoreData()}
                        loading={loading}
                        pageSize={pageSize}
                        componentType={tab}
                        reports={this.state.collateralItemList || []}
                        fetchReport={this.fetchData}
                        ctaContent={
                            <Flex start fullWidth gap='24px'>
                                <SearchAndFilter
                                    clearAll={() => {
                                        this.setState({
                                            collateralItemList: [],
                                            fromDate: null, toDate: null,
                                            pagination: {
                                                current: 1,
                                                pageSize: pageSize,
                                            },
                                        })
                                        this.fetchData({
                                            fromDate: null, toDate: null, fromApply: false, pagination: {
                                                current: 1,
                                                pageSize: pageSize,
                                            },
                                            tab
                                        })
                                    }}
                                    fetchData={this.fetchData}
                                    pageSize={pageSize}
                                    tab={tab}
                                />
                            </Flex>
                        }
                    />
                }

                <Modal
                    visible={this.state.showPaymentModal}
                    footer={null}
                    closable={true}
                    width={this.state.modalWidth}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showPaymentModal: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <TableView
                        style={{ marginTop: 28 }}
                        tableLayout='auto'
                        columns={columns}
                        dataSource={transactions}
                        loading={loadingTransactions}
                        scroll={{ y: '700px', x: '100%' }}
                    />
                </Modal>
                <Modal
                    visible={this.state.showPassThroughModal}
                    footer={null}
                    closable={true}
                    width={this.state.modalWidth}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showPassThroughModal: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <TableView
                        style={{ marginTop: 28 }}
                        tableLayout='auto'
                        columns={passThroughColumns}
                        dataSource={passThrough}
                        loading={loadingPassThrough}
                        scroll={{ y: '700px', x: '100%' }}
                    />
                </Modal>
                <Modal
                    visible={this.state.showAccountStmtModal}
                    footer={null}
                    onCancel={() => { this.setState({ showAccountStmtModal: false }) }}
                    width={500}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AccountStatement business={this.props.aionStore.BusinessUniqueKey} availableStatements={this.state.availableStatements} modal />
                </Modal>
            </FlexColumn>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.creditAppReducer,
        aionStore: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)));